var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 124,
    viewBox: "0 0 118 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_129_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.4056L59 4.3396V72.6226L12 91.6887V23.4056Z",
    fill: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 103.66V72.6226L12 91.6887L59 103.66Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 103.66V72.6226L106 91.6887L59 103.66Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 23.4056L59 4.3396V72.6226L106 91.6887V23.4056Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_129_143",
    x: 0,
    y: 0.3396,
    width: 118,
    height: 123.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.23096 0 0 0 0 0.533203 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_143",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/Box1.29371a3a149ecf875510472fd82e0afd.svg";
export { ForwardRef as ReactComponent };